import { render, staticRenderFns } from "./base-instance-selection.vue?vue&type=template&id=e7513cc2"
import script from "./base-instance-selection.vue?vue&type=script&lang=js"
export * from "./base-instance-selection.vue?vue&type=script&lang=js"
import style0 from "./base-instance-selection.vue?vue&type=style&index=0&id=e7513cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports